/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};

/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {

/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;

/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};

/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;

/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}


/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;

/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;

/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";

/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

	'use strict';

	var reCaptchaEnterpriseEnabled = $('.contact-us').data('recaptcha-enterprise-enabled');
	var captchaEnabled = $('.contact-us').data('captcha-enable');
	/**
	 * Validate whole form. Requires `this` to be set to form object
	 * @param {Object} $phoneField - Phone number field input.
	 * @returns {boolean} - Flag to indicate if form is valid
	 */
	function validatePhoneNumber($phoneField) {
	    var contactPhone = $phoneField.val();
	    if (contactPhone) {
	        contactPhone = contactPhone.replace(/\s/g, '');
	        $phoneField.val(contactPhone);
	    }
	    // check the phone length
	    var minLength = $phoneField.attr('minlength'),
	        maxLength = $phoneField.data('max'),
	        errorLengthLabel = '',
	        lenghtValid = true;
	    if (minLength && contactPhone.length < parseInt(minLength)) {
	        errorLengthLabel = $phoneField.data('minlength-error');
	        lenghtValid = false;
	    } else if (maxLength && contactPhone.length > parseInt(maxLength)) {
	        errorLengthLabel = $phoneField.data('maxlength-error');
	        lenghtValid = false;
	    }

	    if (lenghtValid) {
	        $phoneField.removeClass('is-invalid custom-error');
	    } else {
	        $phoneField.parents('.cc-form-group').find('.cc-text-message').text(errorLengthLabel);
	        $phoneField.closest('.cc-content-input').removeClass('is-valid');
	        $phoneField.addClass('is-invalid custom-error');
	    }

	    /**
	     * Check the phone pattern - usefull only for th, my, id, in, cl sites. Since these sites do have an extra div (located inside
	     *  a phoneField.isml component) that encapsulates an input phone field.
	     */
	    if ($phoneField.parent().hasClass('cc-phone-input-box')) {
	        var pattern = $phoneField.attr('pattern');
	        var patternValid = pattern && !contactPhone.match(pattern) ? false : true;
	        if (patternValid) {
	            $phoneField.parent().removeClass('is-invalid custom-error');
	        } else {
	            $phoneField.parent().addClass('is-invalid custom-error');
	        }
	    }
	}

	/**
	 * when the user focuses out of the contact phone input label, removes all the whitespaces if present (for example from autofill)
	*/
	$('#contact-phone').on('blur', function () {
	    validatePhoneNumber($(this));
	});

	/**
	 * Method used when the user clicks on the button or outside of the modal and redirect to the homepage
	 */
	$('.js-submit').on('click', function (e) {
	    var modalArea = document.getElementById('js-contactUs-submit');
	    var targetElement = e.target;
	    if (targetElement !== modalArea) {
	        var url = $(e.target).data('redirecturl');
	        window.location.href = url;
	    }
	});

	/**
	 * It's solves an issues when nothing is filled in the phone field and obviously validatePhoneNumber method is not executed
	 * in that case because form's submit event is not executed when there are some html validation errors.
	 */
	$('#contact-phone').on('invalid', function () {
	    // for th, my, id, in, cl sites only
	    if ($(this).parent().hasClass('cc-phone-input-box')) {
	        $(this).parent().addClass('is-invalid custom-error');
	    }
	    $(this).addClass('is-invalid custom-error');
	});

	function countCommentWords() {
	    if ($('#contact-comment').length > 0) {
	        $('#contact-comment').on('keyup', function () {
	            var count = $('#wordCommentCounter');
	            var maxLength = $(this).attr('maxlength');
	            var newMaxLengthValue = parseInt(maxLength);
	            count.text(newMaxLengthValue - this.value.length);
	        });
	    }
	}

	window.captchaError = function () {
	    if (captchaEnabled !== null && captchaEnabled) {
	        $('.captchaMessage').removeClass('d-none');
	        $('.captchaMessage').addClass('invalid-captcha custom-error');
	    }
	};
	window.captchaSuccess = function () {
	    if (captchaEnabled !== null && captchaEnabled) {
	        $('.captchaMessage').addClass('d-none');
	        $('.captchaMessage').removeClass('invalid-captcha custom-error');
	    }
	};
	window.captchaReset = function () {
	    if (captchaEnabled !== null && captchaEnabled) {
	        reCaptchaEnterpriseEnabled ? window.grecaptcha.enterprise.reset() : window.grecaptcha.reset();
	    }
	};

	/**
	 * Ajax script that allows to submit contact us form without refreshing the page and shows modal on submit
	 */
	function subscribeContact() {
	    $('form#contact-us').on('submit', function (e) {
	        e.preventDefault();
	        var form = $(this);
	        var url = form.attr('action');
	        var topic = form.find('#contact-topic option:selected').text().trim();
	        $('input#topic-hidden').attr('value', topic);

	        var captcha = null;
	        if (captchaEnabled) {
	            captcha = reCaptchaEnterpriseEnabled ? window.grecaptcha.enterprise.getResponse() : window.grecaptcha.getResponse();
	            if (captcha.length === 0) {
	                window.captchaError();
	                $('.error-message-contact-us').show();
	                //var test = $('.custom-error').first().parents('.cc-form-group');
	                document.querySelector('.error-message-contact-us').scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });
	                $.spinner().stop();
	            } else {
	                window.captchaSuccess();
	                $('input#captcha-token').attr('value', captcha);
	            }
	        }

	        validatePhoneNumber($('#contact-phone'));
	        // check the phone length
	        if ($('.custom-error').length === 0) {
	            $.spinner().start();
	            $.ajax({
	                url: url,
	                type: 'POST',
	                dataType: 'json',
	                data: form.serialize(),
	                success: function success(data) {
	                    // in case of error, reset the captcha token to avoid timeout
	                    if (!!data.serverErrors && data.serverErrors.length) {
	                        window.captchaReset();
	                        $('.error-message-contact-us').show();
	                        $('.error-message-text-contact-us').text(data.serverErrors);
	                        document.querySelector('.error-message-contact-us').scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });
	                    } else {
	                        $('#exampleModalLongTitle').text(data.title);
	                        $('#modal-body').text(data.msg);
	                        $('#contactUs-modal-submit').modal('show');
	                    }
	                    $.spinner().stop();
	                },
	                error: function error(err) {
	                    $('#exampleModalLongTitle').text(err.title);
	                    $('#modal-body').text(err.msg);
	                    $.spinner().stop();
	                    $('#contactUs-modal-submit').modal('show');
	                }
	            });
	        }
	    });
	}
	subscribeContact();
	countCommentWords();

/***/ })
/******/ ]);